import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search_header flex flexcenter" }

import { query, isValidQuery } from "@/busData";

import FormValidationTooltip from "./FormValidationTooltip.vue";
import SearchIcon from "./SearchIcon.vue";
import Loader from "./Loader.vue";
import CloseSpotlight from "./CloseSpotlight.vue";


export default /*#__PURE__*/_defineComponent({
  emits: ['search', 'handleChange'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SearchIcon),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('search', _unref(query))), ["prevent"])),
        id: "searchForm"
      }, [
        _withDirectives(_createElementVNode("input", {
          onKeydown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handleChange', _unref(query)))),
          onFocusout: _cache[1] || (_cache[1] = ($event: any) => (isValidQuery.value = true)),
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(query) ? (query).value = $event : null)),
          class: "searchQuery",
          placeholder: "Busca conductores, vehículos, facturas..."
        }, null, 544), [
          [_vModelText, _unref(query)]
        ])
      ], 32),
      _createVNode(FormValidationTooltip),
      _createVNode(CloseSpotlight)
    ]),
    _createVNode(Loader)
  ], 64))
}
}

})